import FuseNavigation from '@fuse/core/FuseNavigation';
import clsx from 'clsx';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectNavigation } from 'app/store/fuse/navigationSlice';
import useSidebarItemClick from './SidebarNavigation/hooks/useSidebarItemClick';

function Navigation(props) {
  const { layout = 'vertical' } = props;

  const navigation = useSelector(selectNavigation);
  const handleItemClick = useSidebarItemClick();

  return (
    <FuseNavigation
      className={clsx('navigation', props.className)}
      navigation={navigation}
      layout={layout}
      dense={props.dense}
      active={props.active}
      onItemClick={handleItemClick}
    />
  );
}

export default memo(Navigation);
